import listCourse from "./listCourse/reducer"
import listBanner from "./listBanner/reducer"
export default {
  SuperSchoolMemoryCourseListCourse: listCourse,
  SuperSchoolMemoryCourseListBanner: listBanner,
}
